import { WidgetsAddressesMain } from '@/widgets/addresses';

export const PagesAddressesMain = () => <WidgetsAddressesMain />;
